<app-loadable-content [loadingController]="campaignLoadingController" (onRetry)="loadCampaign()">
    <app-title>{{ campaign.code }}</app-title>
    <div align="center">
        <app-toolbar [subject]="campaign" [actions]="campaignToolbarModel.actions" [compactActions]="campaignToolbarModel.compactActions"></app-toolbar>
    </div>
</app-loadable-content>
